<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img data-src="/assets/manufacture/engine/dingxing/dx.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    变速器定兴工厂
                </div>
                <div class="manufacture-t2">
                    位于河北省保定市定兴县，作为第一个发动机生产工厂，成立于2000年5月份，厂区整体占地约23万平方米；<br />
                    主要生产2.0L柴油机及491平台发动机、缸体、缸盖、曲轴及部分小件（平衡轴、套筒、EGR阀、下缸体）；<br />
                    已具备初步的研、产、供、销全产业配套体系，主营产品主要为整硬回转类、超硬类换片、刀具修磨业务三大业务领域。
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                机加车间
            </div>
            <div class="page-t2">
                共有10条线体，包含两个机加生产车间（ED机加线、EC平衡轴/油底壳机加线）
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                自动化设备单元
                            </div>
                            <div class="destils">
                                曲轴生产线采用柔性加工方式，全部采用肢节式机器人自动上下料，实现全自动生产
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/dingxing/dx1-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                关键工艺（随动磨削工艺）
                            </div>
                            <div class="destils">
                                精加工采用英国Landis公司的磨床，磨削精度圆度在3μm以内、圆柱度在4μm以内、连杆颈平行度达到8μm左右的随动磨床
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/dingxing/dx1-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                珩磨单元
                            </div>
                            <div class="destils">
                                采用德国纳格尔珩磨机及压板珩磨技术，实现缸孔、主轴孔高精度的加工，主轴孔、缸孔圆柱度保证在8μm以内
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/dingxing/dx1-3.jpg" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                精加工设备
                            </div>
                            <div class="destils">
                                ED缸体、缸盖线精加工设备由德国DMG高速加工中心及小巨人高速加工中心实现<br />
                                工艺上采用刚性钻孔、刚性攻丝、高速CBN刀具、高速金刚石刀具等技术
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/dingxing/dx1-4.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                装试车间
            </div>
            <div class="page-t2">
                包含装配/磨试线、磨试线
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/dingxing/dx2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                热试工艺
                            </div>
                            <div class="destils">
                                8min 100%热试，实现发动机各工况性能测试，能够截留242种故障
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/dingxing/dx2-2.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                拧紧机
                            </div>
                            <div class="destils">
                                全轴拧紧机实现各螺栓同步拧紧、实现自动异常力矩自动监测报警并自动通知各负责人，实现力矩追溯
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/dingxing/dx2-3.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                涂胶机
                            </div>
                            <div class="destils">
                                涂胶过程时时监控，拍照，可追溯<br />
                                样板对比功能
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/dingxing/dx2-4.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                压装机
                            </div>
                            <div class="destils">
                                压装卡簧时通过扫描影像100%保证压装到位，避免漏装及压装不到位现象
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/engine/dingxing/dx2-5.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                回转力矩检测机
                            </div>
                            <div class="destils">
                                100%检测缸体回转力矩，有效截留异常缸体、轴瓦、曲轴、止推片追溯
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '变速器定兴工厂 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture/en/dingxing.html'
};

import { createApp } from 'vue';
import App from './dingxing.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./dingxing.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
